import Promise from 'bluebird';
import { ILogger, getErrorString } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

export const getLogger = (activity, page = '', version = '', tag = 'Asset Library') : ILogger => {
  const {
    trace, error, withSignalAsync, // perf, ajax,
  } = activity || {};

  const pageName = page;

  const logTrace = (...args) => {
    const [msg, params, ...rest] = args;
    if (trace) {
      const paramsJson = params ? ` $params: ${JSON.stringify(params)}` : '';
      trace(`[${tag}]${version ? `[${version}]` : ''}${page ? `[${page}]` : ''} ${msg}${paramsJson}`, ...rest);
    }
  };

  const logError = (...args) => {
    const [err, params, ...rest] = args;
    if (error) {
      const paramsJson = params ? ` $params: ${JSON.stringify(params)}` : '';
      const errMsg = getErrorString(err);
      error(`[${tag}] ${errMsg}${paramsJson}`, ...rest);
    }
  };

  const traceWithoutParams = (...args) => {
    const [msg, ...rest] = args;
    if (trace) {
      trace(`[${tag}] ${msg}`, ...rest);
    }
  };

  const monitorPromise = ({
    promise = undefined,
    msg = '',
    api = '',
  } = {}) => {
    if (withSignalAsync && promise) {
      withSignalAsync(new Promise((resolve) => {
        promise.then(() => { // we only record the success case
          resolve({
            message: `[${tag}] ${msg}`,
            api,
          });
        }).catch(() => { // tag the failed case with failed
          resolve({
            message: `[${tag}] ${msg}`,
            api: `${api}_failed`,
          });
        });
      }));
    }
    return promise;
  };

  return {
    pageName,
    logTrace,
    logError,
    traceWithoutParams,
    monitorPromise,
  };
};
